import { render, staticRenderFns } from "./xeChartPieSetting.vue?vue&type=template&id=d286d38e"
import script from "./xeChartPieSetting.vue?vue&type=script&lang=js"
export * from "./xeChartPieSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports